import { IDIncomeVerificationStatus, VerificationFailureAction } from '@common/entities';
import { VerificationFieldState } from 'state/slices/idIncomeVerificationSlice';

import { verificationErrorCount } from 'utils/getErrors';

export const isVerificationCompleted = (status: IDIncomeVerificationStatus | null): boolean => {
  return (
    status === IDIncomeVerificationStatus.Success || status === IDIncomeVerificationStatus.Failed
  );
};

export const isVerificationFailed = (verification: VerificationFieldState): boolean => {
  return verification.status === IDIncomeVerificationStatus.Failed;
};

export const shouldLockdownOnFailure = (verification: VerificationFieldState): boolean => {
  return (
    verification.verificationFailureAction === VerificationFailureAction.LockdownTheApplication
  );
};

export const isVerificationBlocking = (verification: VerificationFieldState): boolean => {
  return isVerificationFailed(verification) && shouldLockdownOnFailure(verification);
};

/**
 * Determine if the application can be completed based on verification status
 * Returns true if there are no verification errors blocking completion
 */
export function allowToCompleteTheApplication(verificationData: VerificationFieldState): boolean {
  // Use verificationErrorCount to determine if there are any blocking errors
  // Returns 0 if no errors, 1 if there are errors
  return verificationErrorCount(verificationData) === 0;
}
